import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NgxSpinnerTextService {
    currentText = '';
}
